module.exports = __webpack_public_path__ + "static/media/tick.0026a76d.svg";